<div class="relative min-h-screen flex flex-col bg-[#f0f2f8]">
    <!--Navbar Start-->
    <app-navbar></app-navbar>
    <!--Navbar End-->

    <div class="flex-grow">
        <!-- Top Banner Section Start -->
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/specialities-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[5em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">Specialities</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <div class="container mx-auto p-10 md:mb-5 xl:mb-0">
            <!-- Mat Spinner  -->
            <ngx-spinner bdColor="rgba(256, 256, 256, 0.5)" size="default" color="#6eabc6" type="ball-spin-fade"
                [fullScreen]="true">
                <p style="color: black"> Fetching specialities... </p>
            </ngx-spinner>

            <div class="container" *ngIf="selectedHospitalName">
                <div class="custom-margin">
                    <h2 class="text-right">Selected Hospital : <span class="text-[#112c76e8]">{{selectedHospitalName}}</span></h2>
                </div>
            </div>

            <!-- Specialities Content Section Start -->
            <div class="speciality-sec dashboard-page-right lg:flex lg:items-center lg:justify-center sm:col-span-1 md:col-span-1 lg:col-span-1 relative pb-[4em]">
                <div class="container mx-auto md:mb-5 xl:mb-0">
                    <div class="custom-margin mb-[50px] box_title">
                        <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Specialities</span>
                        <h2 class="title mt-0 mb-[20px] font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] max-w-[100%] leading-[1.2em]">Our Departments</h2>
                    </div>
                    <div class="mt-10">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="relative col-span-12 sm:col-span-6 lg:col-span-4 px-[15px] speciality-card"
                                *ngFor="let specialty of paginatedSpecialities;">
                                <div class="speciality-card-inner rounded-[30px]">
                                    <div class="relative overflow-hidden rounded-[30px] speciality-card-content">
                                        <div class="relative speciality-card-img-wrapper">
                                            <div class="speciality-icon flex items-center justify-start text-[#677db9]">
                                                <span
                                                    class="material-symbols-outlined relative block">medical_information</span>
                                            </div>
                                            <h2
                                                class="speciality-title text-[22px] leading-[32px] pt-[15px] mt-[15px] ms-[12px] relative text-[#000] font-normal cursor-pointer" (click)="gotoSpecialityDoctorsList(specialty)">
                                                {{specialty.title}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-center mt-10" *ngIf="specialities.length > pageSize">
                            <mat-paginator #paginator
                                class="demo-paginator"
                                (page)="handlePageEvent($event)"
                                [length]="length"
                                [pageSize]="pageSize"
                                [disabled]="disabled"
                                [showFirstLastButtons]="showFirstLastButtons"
                                [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
                                [hidePageSize]="hidePageSize"
                                [pageIndex]="pageIndex"
                                aria-label="Select page">
                            </mat-paginator>
                          </div>
                    </div>
                </div>
            </div>

            <div class="custom-margin p-10 custom-border flex justify-center items-center"
                *ngIf="specialities && specialities.length === 0">
                <div class="flex justify-center">
                    <p class="text-[#667ac3] text-center">
                        "Sorry, but we couldn't find any doctors specializing in this field at the moment. Please
                        consider broadening your search criteria or checking back later.<br> If you have any specific
                        questions or need assistance, feel free to contact our support team. We're here to help!"
                    </p>
                </div>
            </div>
            <!-- Specialities Content Section End -->

        </div>
    </div>

    <!-- Footer Start  -->
    <app-message></app-message>
    <app-footer></app-footer>
    <!-- Footer End  -->
</div>